import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Paper, Typography, useTheme } from '@mui/material';
import { useForm, FormProvider } from 'react-hook-form';
import CustomButton from '../../Components/Inputs/CustomButton';
import InputPassword from './InputPassword';
import getErrorMessage from '../../Helpers/Errors/getErrorMessage';

const ChangePwd = function ChangePwd({ loginError = null, onSubmit }) {
  const intl = useIntl();
  const theme = useTheme();

  const [subColor, setSubColor] = useState(theme.palette.greys.title);
  const [subtitles, setSubtitles] = useState([
    intl.messages.COMPILE_FIELDS_TO_CHANGE_PASSWORD,
  ]);

  const {
    register, //sends input data
    formState: { errors, isSubmitted },
    ...methods
  } = useForm();

  useEffect(() => {
    if (loginError?.payload && isSubmitted) {
      setSubColor(theme.palette.error.main);
      setSubtitles(
        getErrorMessage(loginError, intl).split(',') || [
          intl.messages.CHANGE_PWD_ERROR,
        ]
      );
    }
  }, [loginError]);

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Paper
            elevation={3}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: '48px',
              minWidth: '600px',
              borderRadius: '18px',
            }}
          >
            <Typography variant="h4" sx={{ color: 'greys.title' }}>
              {intl.messages.CHANGE_PASSWORD}
            </Typography>
            {subtitles.map((sub, index) => (
              <Typography
                key={sub}
                variant="subtitle1"
                sx={{
                  mb: index === subtitles.length - 1 ? '24px' : null,
                  color: subColor,
                  width: '100%'
                }}>
                {sub}
              </Typography>
            ))}
            <InputPassword
              label={intl.messages.OLD_PASSWORD}
              register={register}
              name="oldPassword"
              errors={errors?.oldPassword}
              fullWidth
            />
            <InputPassword
              label={intl.messages.NEW_PASSWORD}
              register={register}
              name="newPassword"
              errors={errors?.newPassword}
              fullWidth
            />
            <InputPassword
              label={intl.messages.CONFIRM_PASSWORD}
              register={register}
              name="confirmPassword"
              error={errors?.confirmPassword}
              fullWidth
              customValidation={(value, formValues) =>
                value !== formValues?.newPassword
                  ? intl.messages.PASSWORD_MISMATCH
                  : true
              }
            />
            <Link
              onClick={() => {
                setSubtitles([intl.messages.COMPILE_FIELDS_TO_CHANGE_PASSWORD]);
              }}
              to={-1}
              style={{
                textDecoration: 'none',
                fontFamily: 'Roboto',
                marginBottom: '10px',
              }}
              tabIndex={-1} //make it unfocusable with tab key
            >
              {intl.messages.BACK}
            </Link>
            <CustomButton
              type="submit"
              styles={{
                mb: '24px',
                height: '50px',
                mt: '8px',
              }}
              label={intl.messages.CHANGE_PASSWORD}
            />
          </Paper>
        </div>
      </form>
    </FormProvider>
  );
};

ChangePwd.propTypes = {
  loginError: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};
export default ChangePwd;
